var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-dialog',{attrs:{"width":"884"},on:{"click:outside":_vm.closeModal},model:{value:(_vm.showModal),callback:function ($$v) {_vm.showModal=$$v},expression:"showModal"}},[_c('v-card',{staticClass:"modal-preview"},[_vm._v(" Video is currently being processed, it will be ready in a few minutes ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }